import { LoadingOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getUpgradeFlag } from "services/lookupSelector";
import { Button } from "shared/components/Button";
import env from "shared/constants/env";
import routes, { appRoute } from "shared/constants/routes";
import { useTranslation } from "../../../contexts/TranslationContext";

// Helper function to get the correct endpoint based on application source
const getEndpointForApp = (appId) => {
  const upgradedUser = getUpgradeFlag();

  // For v2 users, always use v2 endpoint
  // if (upgradedUser) {
  //   return env.API_ENDPOINT_V2;
  // }

  // For v1 users, check application source
  try {
    const appSourceMap = JSON.parse(localStorage.getItem('userAppsSourceMap') || '{}');
    if (appSourceMap[appId]) {
      return appSourceMap[appId] === 'v1' ? env.API_ENDPOINT : env.API_ENDPOINT_V2;
    }
  } catch (error) {
    console.error("Error checking cached app source:", error);
  }

  // Fallback to v1 for v1 users
  return env.API_ENDPOINT;
};


export default function CancelModal({ appId }) {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { translate } = useTranslation();

  const handleConfirm = async () => {
    try {
      setLoading(true);

      // Determine endpoint based on application source
      const endpoint = `${getEndpointForApp(appId)}app/customer-contract-decision`;

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerStatus: 'REJECTED',
          appId: `${appId}`,
        }),
      });

      const data = await response.json();

      if (data?.success) {
        toast.success('Contract Rejected');
      } else {
        toast.error(data?.message || "Unable to reject Contract");
      }
    } catch (ex) {
      toast.error("Unable to reject Contract, please try again");
    } finally {
      setLoading(false);
      setIsOpen(false);
      navigate(appRoute(routes.HOME));
    }
  };

  return (
    <>
      <Button onClick={() => setIsOpen(true)} color="primary" mode="outline" className="rounded-xl h-12 w-32">
        {translate("CONTRACT.REJECT")}
      </Button>
      <Modal
        open={isOpen}
        // title="Reject Contract?"
        title={translate("CONTRACT.REJECT_QUESTION")}

        onCancel={() => setIsOpen(false)}
        footer={
          <Button disabled={loading} onClick={handleConfirm} color="primary" className="rounded-xl min-w-32">
            {loading ? <LoadingOutlined /> : translate("CONTRACT.REJECT")}
          </Button>
        }
      >
        {translate("CONTRACT.CONFIRM_REJECTANCE")}
      </Modal>
    </>
  );
}
